import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { tableCellCentered } from '../../../../../../../assets/js/styles'
import {
  Badge,
  Btn,
  CustomCheckbox,
  CustomModal,
  NumeroDecimal,
} from '../../../../../../../components'
import { hideLoadingBox, showMessageBox } from '../../../../../../../store/actions/system.actions'
import useModalAssocCarga, { LOAD_MESSAGE } from './ModalAssocCargaHook'
import * as colors from '../../../../../../../assets/js/colors'
import { formatIsoDateToLocale } from '../../../../../../../services/util/date.service'
import ModalTentativaReentrega from '../../../../RetornoVeiculoApuracao/ModalTentativaReentrega/ModalTentativaReentrega'

function ModalAssocCarga({
  dispatch,
  onModalClose,
  onModalSave,
  show,
  customer,
  loadCounter,
  updateLoadCounter,
}) {
  const { state, localDispatch } = useModalAssocCarga()
  const [modalTentativaReentrega, setModalTentativaReentrega] = useState({ show: false, data: null })

  useEffect(() => {
    if (show) localDispatch.onInit(show, customer)
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE_ASSOCIATIONS:
        onModalSave(state.customer)
        localDispatch.resetState()
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header={`Associar Cargas - ${customer ? customer.nomeFantasia : 'Lorem Ipsum Dolor'}`}
      isVisible={show}
      onClose={() => {
        onModalClose()
      }}
      width={1100}
      contentStyle={{ maxHeight: '75vh', overflowY: 'auto' }}
    >
      <div className="p-grid">
        <div className="p-col-6">
          <label style={{ display: 'block', color: colors.azul }}>Peso Total - KG:</label>
          <label style={{ fontSize: '1rem', fontWeight: 'bold', color: colors.azul }}>
            <NumeroDecimal decimalScale={0}>{state.pesoTotal}</NumeroDecimal>
          </label>
        </div>
        <div className="p-col-6">
          <label style={{ display: 'block', color: colors.azul }}>Peso Selecionado - KG:</label>
          <label style={{ fontSize: '1rem', fontWeight: 'bold', color: colors.azul }}>
            <NumeroDecimal decimalScale={0}>{state.pesoSelecionado}</NumeroDecimal>
          </label>
        </div>
        <div className="p-col-12">
          <label style={{ display: 'block', color: colors.azul }}>Endereço:</label>
          <label style={{ fontSize: '1rem', fontWeight: 'bold', color: colors.azul }}>
            {state.customer.deliveries.length && (
              <p>
                {' '}
                {state.customer.deliveries[0].address}, {state.customer.deliveries[0].district} -{' '}
                {state.customer.deliveries[0].city}
              </p>
            )}
          </label>
        </div>
        <div className="p-col-12">
          <CustomCheckbox
            checked={state.selecionarTodos}
            onChange={() => {
              localDispatch.onSelectedAllClick(loadCounter, updateLoadCounter)
            }}
          >
            Selecionar Todos
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <DataTable
            value={state.customer.deliveries}
            paginator={true}
            rows={10}
            header={
              <div className="p-grid">
                <div className="p-col-12">Entregas para associação</div>
              </div>
            }
            emptyMessage={'Todas as cargas ja foram associadas'}
          >
            <Column
              header={'Associar'}
              body={item => {
                if (item.status_id !== 5)
                  return (
                    <CustomCheckbox
                      checked={item.selected}
                      onChange={() => {
                        localDispatch.onItemClicked(item, loadCounter, updateLoadCounter)
                      }}
                    />
                  )
              }}
              style={tableCellCentered(80)}
            />
            <Column
              field="identifier"
              header="Identificador"
              body={item => {
                const isReentrega = item.status_id === 12
                const hasAttemptDate = isReentrega && item.last_attempt_date

                if (hasAttemptDate) {
                  const dateStr = new Date(item.last_attempt_date).toLocaleString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  }).replace(', ', ' ')
                  return (
                    <div
                      style={{ cursor: 'pointer' }}
                      title="Ver tentativa de reentrega"
                      onClick={() =>
                        setModalTentativaReentrega({
                          show: true,
                          data: {
                            delivery_event_id: item.event_id,
                            last_attempt_date: item.last_attempt_date,
                            last_attempt_justify: item.last_attempt_justify,
                          },
                        })
                      }
                    >
                      <Badge color={colors.laranja}>
                        <span style={{ fontSize: '0.72rem' }}>{item.identifier}</span>
                      </Badge>
                      <div style={{ fontSize: '0.72rem', marginTop: 2 }}>
                        <strong style={{ color: '#333' }}>Data ult. tentativa: {dateStr}</strong>
                      </div>
                    </div>
                  )
                }

                if (isReentrega) {
                  return <Badge color={colors.laranja}>{item.identifier}</Badge>
                }

                if (item.status_id === 5) {
                  const color = state.customer.vehicles.length
                    ? state.customer.vehicles.find(
                        vehicles => vehicles.vehicles_id === item.vehicle_id,
                      ).color
                    : colors.gray
                  return <Badge color={color}>{item.identifier}</Badge>
                }
                return item.identifier
              }}
            />
            <Column field="company_name" header="Empresa" />
            <Column field="qte_sku" header="Qte. de Caixas" style={tableCellCentered(80)} />
            <Column field="weight" header="Peso" style={tableCellCentered(80)} />
            <Column field="valor_nf" header="Valor" style={tableCellCentered(80)} />
            <Column field="created_at" header="Data Importação" style={tableCellCentered(100)} />
            <Column field="grupos_produtos" header="Grupo de Produto" />
            <Column
              field="agendamento_entrega"
              header="Agendamento Entrega"
              style={tableCellCentered(100)}
              body={i =>
                i.agendamento_entrega
                  ? formatIsoDateToLocale(i.agendamento_entrega).toFormat('dd/MM/yyyy HH:mm')
                  : ''
              }
            />
          </DataTable>
        </div>
        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onBtnSalvarClicked()}>Salvar</Btn>
        </div>
      </div>
      <ModalTentativaReentrega
        show={modalTentativaReentrega.show}
        entrega={modalTentativaReentrega.data}
        readOnly={true}
        onModalClose={() => setModalTentativaReentrega({ show: false, data: null })}
        onModalSave={() => setModalTentativaReentrega({ show: false, data: null })}
      />
    </CustomModal>
  )
}

export default connect()(ModalAssocCarga)
